export const retrieveSales = (state, payload) => {
  state.sales = payload.data
  state.pagination.links = payload.links
  state.pagination.meta = payload.meta
}

/**
 * @param state
 * @param data
 */
export const pushItemIntoArray = (state, data) => {
  state.selectedSales.push(data)
}

/**
 * @param state
 * @param data
 */
export const popItemFromArray = (state, data) => {
  let index = state.selectedSales.indexOf(data)
  state.selectedSales.splice(index,1)
}

/**
 * @param state
 */
export const cleanArray = (state) => {
  state.selectedSales.length = 0
}
